<template>
  <div class="controls">
    <button
      class="control play"
      :disabled="disabled"
      @click="playing = !playing"
    >
      <Transition name="control">
        <Icon v-if="!playing" name="mdi:play" />
        <div v-else class="playing">
          <div
            class="radial-progress"
            style="--size: 64px; --thickness: 2px"
            :style="`--value: ${percentageRemaining};`"
          >
            <Icon class="w-[45px]" name="IconSpectrum" />
          </div>

          <div class="control-sm absolute right-0 bottom-0 opacity-80">
            <Icon class="" name="mdi:pause" />
          </div>
        </div>
      </Transition>
    </button>
    <audio
      class="hidden"
      ref="audio"
      type="audio/mpeg"
      controls
      controlslist="nofullscreen nodownload noremoteplayback"
      :src="src"
    >
      <a class="sr-only" :href="src">{{ t('download') }}</a>
    </audio>
  </div>
</template>

<script lang="ts" setup>
const { t } = useI18n()
const props = defineProps<{
  src?: string
  type?: string
  disabled: boolean
}>()

// const { src } = toRefs(props)
const src = computed(() => props.src || '')
const disabled = computed(() => props.disabled || false)

const audio = ref<HTMLAudioElement>()
const { playing, currentTime, duration, onSourceError } = useMediaControls(
  audio,
  {
    src,
  },
)

onSourceError((event) => {
  const type = event.type
  const detail =
    event instanceof UIEvent ? event.detail : 'Audio playback error'
  const timeStamp = event.timeStamp

  console.error('Audio playback error', { type, detail, timeStamp })
})

const percentageRemaining = computed(() =>
  Math.ceil((currentTime.value / duration.value) * 100),
)
</script>

<i18n lang="json">
{
  "en": {
    "download": "Download",
    "file-type": "MP3"
  },
  "es": {
    "download": "Descargar",
    "file-type": "MP3"
  }
}
</i18n>

<style lang="postcss" scoped>
.control-base {
  @apply flex place-content-center items-center rounded-full shadow-md shadow-gray-500 dark:shadow-base-200;
}

.on-white {
  @apply bg-base-100 text-brand-peacock disabled:bg-gray-300 disabled:text-gray-700 dark:bg-secondary dark:text-brand-sky;
}

.on-blue {
  @apply bg-brand-peacock text-base-100 disabled:bg-gray-300 disabled:text-gray-700 dark:bg-secondary dark:text-brand-sky;
}

.control {
  @apply control-base on-white h-[4rem] w-[4rem] text-5xl hover:scale-105 active:scale-90;
}

.control-sm {
  @apply control-base on-blue h-[1.25rem] w-[1.25rem] text-xl;
}
</style>

<style>
.control-enter-active,
.control-leave-active {
  transition: opacity 500ms ease;
}

.control-leave-active {
  position: absolute;
}

.control-enter-from,
.control-leave-to {
  opacity: 0;
}
</style>
